// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__37mEc","rootSmall":"AddTileButton_rootSmall__2QIEb"};